import $ from 'jquery'
import Swal from "sweetalert2"
import store from "@/store"
import api from "@/services/api"
export let mixins = {
    data() {
        return {
            filter: {
                page: 0,
                size: 10,
                search: ''
            },
            rows: 0,
        }
    },
    props: {
        moreClass: String,
    },
    computed: {
      getVariant() {
        return {
          'Crítico': '#ff0000',
          'Alto': '#fc7b03',
          'Médio': '#fcbe03',
          'Baixo': '#27c42f',
          'Informativo': '#2785c4',
          'Media': '#F2C94C',
          'Alta': '#F2994A',
          'Baixa': '#27AE60',
          'undefined': 'secondary'
        }
      }
    },
    methods: {
      getComplexityName(value) {
        return {
          COMPLEX: 'Complexo',
          SIMPLE: 'Simples',
        }[value] || '-'
      },
      getStatusName(item){
        const status = {
          disable:'Inativo',
          enable: 'Ativo',
          scanning: 'Escaneando',
          scanningGoogle: 'Escaneando Google',
          scanningCommChannel:'Escaneando Canal',
          scanningLeaks:'Escaneando Vazamento',
          scanningDarkWeb: 'Escanenando Dark Web',
          scanningAOneTickets: 'Escaneando One Tickets',
          scanningAOneByTicket: 'Escaneando One By Ticket'
        }
        return status[item] || 'Sem status'
    },
        getJustTextWithoutSpecialCharacters (value){
            return value.normalize('NFD').replace(/[\u0300-\u036f]/g, "")
          },
        startTooltip(id) {
            $(`#${id}`).tooltip();
        },
        swalMessage(data) {
            Swal.fire({
              ...data,
              icon: `${data.type}`,
              title: `${data.title}`,
              text: `${data.text}`,
              confirmButtonColor: '#000',
              cancelButtonColor: '#d33'
            })
        },
        errorCatch(error) {
            if (error.response && error.response.status === 401) {
                if (this.$route.name !== 'login') {
                    this.$router.push('/login')
                    store.commit("utils/setOpenNav", false)
                }
            }
            let data = {
                type: 'error',
                title: 'Ops ...',
                text: `Aconteceu algo de errado! | error : ${error} `
            }
            this.swalMessage(data)
            this.$store.commit('utils/setLoading',false)

        },
          async exportFile(fileName,exportFile) {
            try {
              this.$store.commit("utils/setLoading", true);
              const { data } = await api.exportFileCsv(exportFile,this.filter);
              const url = window.URL.createObjectURL(data);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", fileName); //or any other extension
              document.body.appendChild(link);
              link.click();
            } catch (error) {
              this.errorCatch(error);
            } finally {
              this.$store.commit("utils/setLoading", false);
            }
          },
    },

}